import React from "react";
import { Grid } from "@material-ui/core";

import "./styles.css";

interface PageCustomProps {
	cabecalho: React.ReactNode;
	children: React.ReactNode;
}

const PageCustom: React.FC<PageCustomProps> = (props: PageCustomProps) => {
	const { cabecalho, children } = props;
	return (
		<div className="root">
			<Grid item xs={12}>
				<div className="paper">{cabecalho}</div>
				<div className="paper">{children}</div>
			</Grid>
		</div>
	);
};
export default PageCustom;
